export const DefaultDesktopLeftLng = 139.3324059
export const DefaultDesktopLeftLat = 35.5062596
export const DefaultDesktopUpperLng = 140.1258386
export const DefaultDesktopUpperLat = 35.8998938

export const DefaultMobileLeftLng = 139.6624948
export const DefaultMobileLeftLat = 35.6032304
export const DefaultMobileRightLng = 139.8050996
export const DefaultMobileRightLat = 35.7749789